import React from 'react'
import { Card, CardBody, CardExpandToggler } from '../other/card/card'
import ChartApex from '../other/charts/ChartApex'
import ComponentLoader from '../other/ComponentLoader'
import { useGetDailyReportedRemovedQuery } from '../../redux/apis/analyticsManagement/aMAnalyticsApiSlice'

const MonthlyDetectedRemoved = ({ campaignId } = {}) => {
    const [numOfDays, setNumOfDays] = React.useState(7);
    const params = campaignId ? { num_of_days: numOfDays, campaign_id: campaignId } : { num_of_days: numOfDays };
    const { data, isFetching } = useGetDailyReportedRemovedQuery(params);

    return (
        <div className="col-xl-8 col-lg-12 ">
            <Card className="mb-3">
                <CardBody className="relative p-0">
                    {isFetching ? <ComponentLoader /> : null}
                    <div className='p-4'>
                        <div className="d-flex fw-bold small mb-3">
                            <span className="flex-grow-1">-</span>
                            <CardExpandToggler />
                        </div>
                        <Card>
                            <CardBody>
                                <div className="mb-4">
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>Daily Reported / Removed</div>
                                        <select
                                            style={{ width: "30%", backgroundColor: "transparent" }}
                                            type="select"
                                            className="mt-2"
                                            value={numOfDays}
                                            onChange={(e) => setNumOfDays(e.target.value)}>
                                            <option value="7" className='optionText'>Last 7 days</option>
                                            <option value="14" className='optionText'>Last 14 days</option>
                                            <option value="30" className='optionText'>Last 30 days</option>
                                        </select>
                                    </div>
                                </div>
                                {data ? <ChartApex data={data} numOfDays={numOfDays} /> : <></>}
                            </CardBody>
                        </Card>
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}

export default MonthlyDetectedRemoved
